<template>
  <div class="apply-form">
    <h1 class="form-title">{{ $cms('c_63d6332b901a', 'f_0001', "立即申请，成为品牌合作渠道") }}</h1>
    <div class="form-desc">
      <h2>{{ $cms('c_63d6332b901a', 'f_0002', "渠道合作问卷") }}</h2>
      <p>
        {{ $cms('c_63d6332b901a', 'f_0003', "请详细填写以下信息，我们会根据您的资料评估合作潜力，并在3个工作日内联系商务经理启动1v1洽谈！") }}
      </p>
    </div>
    <div class="form-content">
      <el-form ref="form" :model="form" :rules="rules" :inline="false" label-position="top">
        <!-- 一、渠道基础信息 -->
        <div class="form-section">
          <h3 class="section-title">{{ $cms('c_63d6332b901a', 'f_0004', "一、基础信息") }}</h3>
          
          <el-form-item class="form-item" prop="organizationName" :label="$cms('c_63d6332b901a', 'f_0005', &quot;1. 机构名称：&quot;)">
            <el-input v-model="form.organizationName" :placeholder="$cms('c_63d6332b901a', 'f_0006', &quot;请输入机构名称&quot;)" class="learn"></el-input>
          </el-form-item>

          <el-form-item class="form-item" prop="channelTypes" :label="$cms('c_63d6332b901a', 'f_0007', &quot;2. 渠道类型：&quot;)">
            <el-checkbox-group v-model="form.channelTypes">
              <el-checkbox 
                v-for="option in channelTypeOptions" 
                :key="option" 
                :label="option"
              >
                {{ option }}
              </el-checkbox>
            </el-checkbox-group>
            <el-form-item prop="otherChannelType" :label="$cms('c_63d6332b901a', 'f_0008', &quot;其他&quot;)">
              <el-input v-model="form.otherChannelType" :placeholder="$cms('c_63d6332b901a', 'f_0009', &quot;请输入其他渠道类型&quot;)" class="learn"></el-input>
            </el-form-item>
          </el-form-item>

          <el-form-item class="form-item" prop="coverageArea" :label="$cms('c_63d6332b901a', 'f_0010', &quot;3. 渠道覆盖区域（如线下门店填写城市/商圈）：&quot;)">
            <el-input v-model="form.coverageArea" :placeholder="$cms('c_63d6332b901a', 'f_0011', &quot;请输入渠道覆盖区域&quot;)" class="learn"></el-input>
          </el-form-item>

          <el-form-item class="form-item" prop="userScale" :label="$cms('c_63d6332b901a', 'f_0012', &quot;4. 现有用户规模/年营业额（选填）：&quot;)">
            <el-input v-model="form.userScale" :placeholder="$cms('c_63d6332b901a', 'f_0013', &quot;请输入用户规模/年营业额&quot;)" class="learn"></el-input>
          </el-form-item>
        </div>

        <!-- 二、渠道能力评估 -->
        <div class="form-section">
          <h3 class="section-title">{{ $cms('c_63d6332b901a', 'f_0014', "二、能力评估") }}</h3>
          
          <el-form-item class="form-item" prop="hasSalesTeam" :label="$cms('c_63d6332b901a', 'f_0015', &quot;1. 是否已有成熟销售团队？&quot;)">
            <el-radio-group v-model="form.hasSalesTeam">
              <el-radio 
                v-for="option in salesTeamOptions" 
                :key="option.label" 
                :label="option.label"
              >
                {{ option.text }}
              </el-radio>
            </el-radio-group>
            <div v-if="form.hasSalesTeam === $cms('c_63d6332b901a', 'f_0016', &quot;有&quot;)" class="team-details">
              <div class="row">
                <el-input v-model="form.teamSize" :placeholder="$cms('c_63d6332b901a', 'f_0017', &quot;人数&quot;)" class="team-input" style="width: 120px;"></el-input>
                <span class="separator">{{ $cms('c_63d6332b901a', 'f_0018', "人，职能：") }}</span>
                <el-input v-model="form.teamFunction" :placeholder="$cms('c_63d6332b901a', 'f_0019', &quot;职能&quot;)" class="team-input" style="width: 200px;"></el-input>
              </div>
            </div>
          </el-form-item>

          <el-form-item class="form-item" prop="coreAdvantages" :label="$cms('c_63d6332b901a', 'f_0020', &quot;2. 核心资源优势（多选）：&quot;)">
            <el-checkbox-group v-model="form.coreAdvantages">
              <el-checkbox 
                v-for="option in coreAdvantageOptions" 
                :key="option" 
                :label="option"
              >
                {{ option }}
              </el-checkbox>
            </el-checkbox-group>
            <div class="private-domain-details" v-if="form.coreAdvantages.includes($cms('c_63d6332b901a', 'f_0021', &quot;私域流量池&quot;))">
              <span>{{ $cms('c_63d6332b901a', 'f_0022', "（约") }}</span>
              <el-input v-model="form.privateDomainSize" :placeholder="$cms('c_63d6332b901a', 'f_0023', &quot;人数&quot;)" class="number-input"></el-input>
              <span>{{ $cms('c_63d6332b901a', 'f_0024', "人）") }}</span>
            </div>
            <el-form-item prop="otherAdvantage" :label="$cms('c_63d6332b901a', 'f_0025', &quot;其他&quot;)">
              <el-input v-model="form.otherAdvantage" :placeholder="$cms('c_63d6332b901a', 'f_0026', &quot;请输入其他优势&quot;)" class="learn"></el-input>
            </el-form-item>
          </el-form-item>
        </div>

        <!-- 三、补充说明 -->
        <div class="form-section">
          <h3 class="section-title">{{ $cms('c_63d6332b901a', 'f_0027', "三、补充说明") }}</h3>
          <el-form-item class="form-item" prop="expectations" :label="$cms('c_63d6332b901a', 'f_0028', &quot;请简述您对本次合作的期待或建议（50字内）：&quot;)">
            <el-input 
              v-model="form.expectations" 
              type="textarea" 
              :rows="3"
              maxlength="50"
              show-word-limit
:placeholder="$cms('c_63d6332b901a', 'f_0029', &quot;请输入您的期待或建议&quot;)"
              class="learn"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div 
      class="submit-btn" 
      :class="{ 'submitting': isSubmitting }"
      @click="submitForm"
    >
      <span v-if="!isSubmitting">{{ $cms('c_63d6332b901a', 'f_0030', "提交申请") }}</span>
      <span v-else>{{ $cms('c_63d6332b901a', 'f_0031', "提交中...") }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Type4Form',
  props: {
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        organizationName: '',
        channelTypes: [],
        otherChannelType: '',
        coverageArea: '',
        userScale: '',
        hasSalesTeam: '',
        teamSize: '',
        teamFunction: '',
        coreAdvantages: [],
        privateDomainSize: '',
        otherAdvantage: '',
        expectations: ''
      },
      // 选项数据
      channelTypeOptions: [
        '线上电商（淘宝/京东/拼多多等）',
        '线下门店',
        '跨境电商',
        '社群团购',
        '即时零售'
      ],
      salesTeamOptions: [
        { label: '无', text: '无（需我方培训支持）' },
        { label: '有', text: '有' }
      ],
      coreAdvantageOptions: [
        '电商带货矩阵',
        'KA客户资源',
        '私域流量池',
        '商场/社区点位',
        '政府/企业集采资质'
      ],
      rules: {
        organizationName: [
          { required: true, message: '请输入机构名称', trigger: 'blur' },
        ],
        channelTypes: [
          { required: true, message: '请选择渠道类型', trigger: 'change' },
        ],
        coverageArea: [
          { required: true, message: '请输入渠道覆盖区域', trigger: 'blur' },
        ],
        hasSalesTeam: [
          { required: true, message: '请选择是否已有成熟销售团队', trigger: 'change' },
        ],
        coreAdvantages: [
          { required: true, message: '请选择核心资源优势', trigger: 'change' },
        ],
      }
    }
  },
  methods: {
    // 提交表单
    submitForm() {
      if (this.isSubmitting) {
        return; // 如果正在提交，直接返回
      }
      
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log('表单数据:', this.form);
          this.$emit('submit', this.form);
        } else {
          this.$message.error('请填写完整信息');
        }
      });
    },

    // 获取表单数据
    getFormData() {
      return this.form;
    },

    // 验证表单
    validateForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          resolve(valid);
        });
      });
    }
  },
}
</script>

<style lang="less" scoped>
@import "./apply-join.less";

.form-section {
  margin-bottom: 40px;
  
  .section-title {
    font-weight: 600;
    font-size: 20px;
    color: #333333;
    line-height: 28px;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #DCDFE6;
  }
}

.team-details {
  margin-top: 15px;
  
  .row {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    
    .team-input {
      width: 120px;
    }
    
    .separator {
      color: #333;
      font-weight: 500;
    }
  }
}

.private-domain-details {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 10px;
  
  .number-input {
    width: 100px;
  }
  
  span {
    color: #333;
    font-weight: 500;
  }
}

/deep/ .el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 20px;
  
  .el-checkbox {
    margin-right: 0;
  }
}

/deep/ .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 20px;
  
  .el-radio {
    margin-right: 0;
  }
}

/deep/ .el-form-item__label {
  font-weight: 500;
  color: #333;
}

/deep/ .el-textarea__inner {
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  
  &:focus {
    border-color: #FF6600;
  }
}
</style>
